/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserStatsDto } from '../../models/user-stats-dto';

export interface SuperadminControllerGetUserStats$Params {
  uuid: string;
}

export function superadminControllerGetUserStats(http: HttpClient, rootUrl: string, params: SuperadminControllerGetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<UserStatsDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetUserStats.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserStatsDto>;
    })
  );
}

superadminControllerGetUserStats.PATH = '/superadmin/users/{uuid}/stats';
